/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* Thunks */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/**
 * Fetches the invitations from the server
 */
export const fetchInvitations = createFOAsyncThunk('invitations/fetchInvitations', async (arg) => {
  const { pagingSortingAndFiltering, organizationId } = arg;
  const invitationsPage = await userApi.getInvitations(organizationId, pagingSortingAndFiltering);

  return { invitationsPage };
});
